module.exports = "/_next/static/images/168e2acfe61545358e786f5b98b2ae2e-woman-with-yellow-glasses@0.75x.jpg";